import { awsS3ApiPath, awsS3PrivateBucketName } from 'configs/variables';
import { last, omit } from 'lodash';

import useHttpClient from 'hooks/useHttpClient';
import { useMutation } from '@tanstack/react-query';
import { useS3Download } from './use-s3-download';

export function useS3PrivateUpload({ allowDownload = true, ...props }) {
  const { post } = useHttpClient();

  const { mutateAsync } = useS3Download();

  const forceRequest = ({ _, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const mutation = useMutation({
    mutationFn: async (payload) => {
      const newPayload = {
        file_name: payload.file.name,
        file_extension: payload?.fileExtension || last(payload.file.name.split('.')),
        module: payload.module,
        group: payload.group,
        bucket_name: awsS3PrivateBucketName,
      };

      const fn = await post({ url: awsS3ApiPath + '/upload', payload: newPayload });

      return {
        ...fn,
        payload: {
          ...payload,
          ...newPayload,
        },
      };
    },
    async onSuccess(response) {
      if (response.statusCode !== 200) {
        props?.onError?.();
        return;
      }

      if (allowDownload) {
        const url = response.body.url_upload;

        const formData = new FormData();
        const fields = omit(response.body.fields, 'Content-Type');
        Object.entries(fields).forEach((items) => {
          formData.append(items[0], items[1]);
        });

        const blobFile = await response.payload?.file?.arrayBuffer().then((res) => {
          const blobs = new Blob([res]);
          return blobs;
        });

        formData.append('file', blobFile, response.payload?.file_name);

        try {
          const { file_extension: _fileExtension, file_name: _fileName, module, group, uid = '' } = response.payload;
          return await fetch(url, {
            method: 'POST',
            body: formData,
          }).then(() => {
            mutateAsync({
              fileExtension: _fileExtension,
              fileName: response.body.file_name,
              module,
              group,
            })
              .then((res) => {
                props?.onSuccess?.({
                  ...response,
                  ...res.body,
                  fileExtension: _fileExtension,
                  uid,
                });
              })
              .catch(() => {
                throw new Error('');
              });
          });
        } catch (error) {
          props?.onError?.();
        }
      } else {
        return response;
      }
    },
    onError(es) {
      console.error(es);
      props?.onError?.();
    },
  });

  return {
    ...mutation,
    forceRequest,
  };
}
